module.exports = __webpack_public_path__ + "static/img/icon_32_qq.59fc7d68.svg";